import Vue from 'vue'
import Web3 from 'web3'
import config from '@/constants/config'

const toGwei = (number) => String(Math.trunc(number * 1e9));

export const state = Vue.observable({
    fetched: false,
    gasPriceInfo: {},
    gasPrice: 20,
    gasPriceWei: "20000000000",
    gasPriceInterval: null,
})

export const getGasFields = ({ forcePreEip1559 = false } = {}) => (
    (config.blockchainId === 'ethereum' && !forcePreEip1559) ? {
        maxPriorityFeePerGas: Web3.utils.toHex(toGwei(state.gasPrice)),
        maxFeePerGas: Web3.utils.toHex(toGwei(state.gasPriceInfo.base + (state.gasPriceInfo.base * 2 * 0.125) + state.gasPrice)),
    } : (config.blockchainId === 'ethereum' && forcePreEip1559) ? {
        gasPrice: toGwei(state.gasPriceInfo.base + state.gasPrice),
    } : {
        gasPrice: state.gasPriceWei,
    }
);
